module.exports = __webpack_public_path__ + "static/media/mobile-background-input-forms.f551f07f.png";